import React, { Component } from 'react';
import classnames from 'classnames';
import { browserHistory } from 'react-router';
import ReactResizeDetector from 'react-resize-detector';
import Nav from '../../components/nav/Nav';
import ContentDescription from '../../components/content-description/ContentDescription';
import ContentPics from '../../components/content-pics/ContentPics';
import ContentFooter from '../../components/content-footer/ContentFooter';
import ContentRelatedProject from '../../components/content-related-project/ContentRelatedProject';
import Footer from '../../components/footer/Footer';
import ContentDetailInfo from '../../components/content-detail-info/ContentDetailInfo';
import contentUtils from '../../utils/content';
import langIsEn from '../../utils/langIsEn';
import Loading from '../../components/loading-v2/LoadingV2';
import BaseMeta from '../../components/base-meta/BaseMeta';
import styles from './Content.css';

class Content extends Component {
  constructor(props) {
    super(props);

    this.onLangChange = this.onLangChange.bind(this);

    const { engName } = this.props.params;
    const content = contentUtils.getContent(engName);
    this.state = {
      langIsEn: langIsEn(),
      loadingAnimDone: false,
      content: content,
      descriptionHeight: 0,
      viewPortHeight: 0,
    };
  }

  componentWillMount() {
    if (!this.state.content) {
      browserHistory.replace('/notFound');
    }
  }

  componentWillUpdate(nextProps) {
    if (this.props.params.engName !== nextProps.params.engName) {
      const { engName } = nextProps.params;
      if (engName) {
        const content = contentUtils.getContent(engName);
        this.setState(
          {
            langIsEn: langIsEn(),
            loadingAnimDone: false,
            content: content,
            descriptionHeight: 0,
            viewPortHeight: 0,
          }
        );
      }
    }
  }

  onLangChange() {
    this.setState({ langIsEn: langIsEn() });
  }

  onHeightCalculated(descriptionHeight) {
    this.setState({ descriptionHeight });
  }

  onResize() {
    const viewPortHeight =
      Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    this.setState({ viewPortHeight });
  }

  isAllowToFixContentDescription() {
    const { descriptionHeight, viewPortHeight } = this.state;
    if (!descriptionHeight || !viewPortHeight) {
      return false;
    }
    return descriptionHeight < viewPortHeight;
  }

  getFirstImage(pics) {
    for (let i = 0; i < pics.length; i++) {
      const pic = pics[i];
      const { carousel } = pic;

      if (carousel) {
        return pic.attachments[0].url;
      } else {
        for (let j = 0; j < pic.attachments.length; j++) {
          const attachment = pic.attachments[j];
          if (attachment.type !== 'video/mp4') {
            return attachment;
          }
        }
      }
    }

    return null;
  }

  render() {
    if (!this.state.content) {
      return null;
    }

    const {
      loadingAnimDone,
      content: {
        engName,
        chtName,
        engContent,
        chtContent,
        infos,
        pics,
        relatedProjects,
      },
      descriptionHeight,
    } = this.state;
    const firstImage = this.getFirstImage(pics);

    if (!loadingAnimDone) {
      setTimeout(() => this.setState({ loadingAnimDone: true }), 1000);
      return (
        <BaseMeta
          path={this.props.location.pathname}
          title={engName}
          description={engContent}
          imageUrl={firstImage.thumbnailsUrl}
          imageType={firstImage.type}
          imageWidth={firstImage.width}
          imageHeight={firstImage.height}
        >
          <Loading hide />
        </BaseMeta>
      );
    }

    let styleForDescription = {};
    let styleForPics = {};
    if (this.isAllowToFixContentDescription()) {
      styleForDescription = {
        position: 'fixed',
      }
      styleForPics = {
        top: `${descriptionHeight}px`,
      };
    }

    return (
      <main>
        <ReactResizeDetector handleWidth handleHeight onResize={this.onResize.bind(this)} />
        <BaseMeta
          path={this.props.location.pathname}
          title={engName}
          description={engContent}
          imageUrl={firstImage.thumbnailsUrl}
          imageType={firstImage.type}
          imageWidth={firstImage.width}
          imageHeight={firstImage.height}
        />
        <Nav activeItem="projects" onLangChange={this.onLangChange} />
        <div className={classnames({ 'animated fadeIn': loadingAnimDone })}>
          <div
            className={styles.contentDescription}
            style={styleForDescription}
          >
            <ContentDescription
              engName={engName}
              chtName={chtName}
              engContent={engContent}
              chtContent={chtContent}
              infos={infos}
              onHeightCalculated={this.onHeightCalculated.bind(this)}
            />
          </div>
          {descriptionHeight !== 0 &&
            <div
              className={styles.contentDetails}
              style={styleForPics}
            >
              <ContentPics
                pics={pics}
              />
              <ContentDetailInfo infos={infos} />
              <ContentFooter
                shareUrl={window.location.href}
              />
              {relatedProjects && relatedProjects.length !== 0 &&
                <div className="container">
                  <p className={styles.relatedProjectsTitle}>Related Projects</p>
                  <div className={classnames(styles.relatedProjectsRow, 'row')}>
                    {relatedProjects.map((project, idx) => (
                      <ContentRelatedProject project={project} key={`related-project-${idx}`} />
                    ))}
                  </div>
                </div>
              }
              <Footer />
            </div>
          }
        </div>
      </main>
    );
  }
}

export default Content;



// WEBPACK FOOTER //
// ./src/containers/content/Content.js